import { API_BASE_URL, DEV_API_BASE_URL_KEY, ReadLocalStorage } from "common/utility";

const config = {
  API_URL: ReadLocalStorage(DEV_API_BASE_URL_KEY) || API_BASE_URL || "https://stapi.360linked.com",
  // API_URL: process.env.REACT_APP_API_URL || "https://stapi.360linked.com",
};

export default config;
